
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { NavigationItem } from '../../../framework/navigation/NavigationItem';
import { sharedState } from '../../../framework/state';

@Component
export default class CustomerSelector extends Vue {
    @Prop(String) readonly customerId!: string;

    shared = sharedState;

    local = {
        selectedCustomer: {} as NavigationItem,
        name: '',
    };

    mounted() {
        this.setSelectedCustomer();
    }

    get filteredDataArray(): NavigationItem[] {
        return this.shared.navigationStartMenus[0].children.filter((option) => {
            if (!option || !option.label) {
                return false;
            }

            return option.label.toLowerCase().indexOf(this.local.name.toLowerCase()) >= 0;
        });
    }

    @Watch('$route')
    routeChange() {
        this.setSelectedCustomer();
    }

    @Watch('local.selectedCustomer')
    selectedCustomerChange(navItem: NavigationItem) {
        if (!navItem || !navItem.url || !navItem.label) {
            return;
        }

        this.$router.replace(navItem.url);
        this.local.name = navItem.label;
    }

    private setSelectedCustomer() {
        const selectedCustomer = this.shared.navigationStartMenus[0].children.find(
            (item) => item.key === this.$route.params.customerId,
        );
        this.local.name = selectedCustomer && selectedCustomer.label ? selectedCustomer.label : '';
    }
}
